import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASE_URL || 'http://localhost:4613/auth',
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('token');
      console.log('Preparing headers, token:', token);
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }

      return headers;
    },
  }),
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials) => ({
        url: '/authenticate',
        method: 'POST',
        body: credentials,
      }),
      transformResponse: (response) => {
        localStorage.setItem('token', response.user.token);
        localStorage.setItem('user', JSON.stringify(response.user));
        return response.user;
      },
    }),
    getProfile: builder.query({
      query: () => {
        console.log('getProfile query executing');
        return {
          url: '/user-get-profile',
          method: 'GET',
        };
      },
      transformResponse: (response) => response.user,
      forceRefetch: ({ currentArg, previousArg }) => process.env.REACT_APP_NODE_ENV === 'development',
      providesTags: ['Profile'],
    }),
    updateProfile: builder.mutation({
      query: (formData) => ({
        url: '/user-edit-profile',
        method: 'PUT',
        body: formData,
        formData: true,
      }),
      invalidatesTags: ['Profile'],
    }),
    logout: builder.mutation({
      queryFn: () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        return { data: null };
      },
      invalidatesTags: ['Profile'],
    }),
  }),
});

export const {
  useLoginMutation,
  useGetProfileQuery,
  useLogoutMutation,
  useUpdateProfileMutation,
} = authApi;